export const urlConfig = Object.freeze({
    main: 'https://nndantas-web.herokuapp.com',
    message: 'https://nndantas-web.herokuapp.com/contact'
});